import React, { useState, useEffect, useRef } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu } from 'quantux-ui';
import CaseDoc from '../case-doc';
import { blue, gray, yellow } from '../../theme';

const IS_NONE_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path fill="#96C8FF" fillRule="evenodd" d="M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8ZM1.714 8.029c0-3.452 2.855-6.248 6.379-6.248 1.475 0 2.83.492 3.907 1.32l-8.938 8.754A6.091 6.091 0 0 1 1.714 8.03ZM4 12.904a6.385 6.385 0 0 0 3.907 1.32c3.524 0 6.379-2.796 6.379-6.247a6.091 6.091 0 0 0-1.348-3.827L4 12.904Z" clipRule="evenodd" /></svg>
);

const CRITIAL_ICON = (
  <svg
    width="16"
    height="13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 12.364 8 0 0 12.364h16Zm-7.273-2.182H7.273V8.728h1.454v1.454ZM7.273 8h1.454V5.091H7.273v2.91Z"
      fill="#FF0"
    />
  </svg>
);

const SUCCESS_ICON = (
  <svg
    width="12"
    height="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6a6 6 0 1 1 12 0A6 6 0 1 1 0 6Zm2.646-.238 1.896 1.796L9.36 3l.641.608-5.458 5.17L2 6.369l.646-.607Z"
      fill="#00B080"
    />
  </svg>
);

const PreOp = (props) => {
  const [showAsaMenu, setShowAsaMenu] = useState(false);
  const [asaScore, setAsaScore] = useState('');

  // ASA Score
  useEffect(() => {
    if (props.asaScore !== asaScore) {
      setAsaScore(props.asaScore);
    }
  }, [props.asaScore]);

  const handleOnClickAsa = (val) => {
    setAsaScore(val);
    setShowAsaMenu(false);
    props.onChangeAsaScore(val);
  };

  const styles = StyleSheet.create({
    intraOpContainer: {
      backgroundColor: '#002248',
      width: '100%',
      height: 'calc(100% - 42px)'
    },
    dataContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
      height: '40px',
      borderBottom: `1px solid ${blue[800]}`
    },
    popupMenuContainer: {
      width: '155px',
      background: blue[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto'
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      background: '#103860',
      // borderRadius: '4px',
      color: gray[300],
      padding: '4px',
      lineHeight: '16px',
      fontSize: '14px',
      marginBottom: '2px',
      height: '40px',
      width: '100%',
      paddingLeft: '8px',
      ':hover:not(.selected)': {
        background: '#184878',
        color: 'white'
      },
      ':last-child': {
        borderBottom: '0'
      }
    },
    menuItemAvatarImg: {
      height: '40px',
      maxHeight: '40px',
      borderRadius: '4px'
    },
    selectedItem: {
      background: gray[800]
    },
    dataItem: {
      position: 'relative',
      background: blue[700],
      fontWeight: 'bold',
      fontSize: '14px',
      height: '24px',
      paddingRight: '16px',
      paddingLeft: '8px',
      borderRadius: '4px'
    }
  });

  const asaRef = useRef();

  return (
    <div className={css(styles.intraOpContainer)}>
      {/* Anesthesia Data */}
      <div className={css(styles.dataContainer)}>
        {/* ASA Score */}
        <div
          ref={asaRef}
          style={{ position: 'relative' }}
        >
          <div
            className={`fx fx__hv-center ${css(styles.dataItem)}`}
            onClick={() => setShowAsaMenu(true)}
          >
            {asaScore.length === 0 ? CRITIAL_ICON : SUCCESS_ICON}
            <span
              className='ml-2'
              style={{
                color: asaScore.length > 0 ? gray[300] : yellow[500]
              }}
            >
              ASA
              {asaScore.length > 0 &&
                <span className='ml-2' style={{ color: blue[400] }}>{asaScore}</span>
              }
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              fill="none"
              style={{
                position: 'absolute',
                bottom: '2px',
                right: '02px'
              }}
            >
              <path fill="#96C8FF" d="M7.146.854A.5.5 0 0 1 8 1.207V5a3 3 0 0 1-3 3H1.207a.5.5 0 0 1-.353-.854L7.146.854Z" />
            </svg>
          </div>
          {showAsaMenu &&
            <PopupMenu
              top={30}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showAsaMenu}
              parent={asaRef}
              onOutsideClick={() => { setShowAsaMenu(false); }}
            >
              <div
                className={css(styles.popupMenuContainer)}
                style={{
                  maxHeight: '340px'
                }}
              >
                <div
                  className={`${asaScore === '1' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '1' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('1')}
                >
                  ASA 1
                </div>
                <div
                  className={`${asaScore === '2' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '2' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('2')}
                >
                  ASA 2
                </div>
                <div
                  className={`${asaScore === '3' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '3' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('3')}
                >
                  ASA 3
                </div>
                <div
                  className={`${asaScore === '4' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '4' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('4')}
                >
                  ASA 4
                </div>
                <div
                  className={`${asaScore === '5' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '5' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('5')}
                >
                  ASA 5
                </div>
                <div
                  className={`${asaScore === '6' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '6' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('6')}
                >
                  ASA 6
                </div>
                <div
                  className={`${asaScore === '1E' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '1E' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('1E')}
                >
                  ASA 1E
                </div>
                <div
                  className={`${asaScore === '2E' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '2E' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('2E')}
                >
                  ASA 2E
                </div>
                <div
                  className={`${asaScore === '3E' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '3E' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('3E')}
                >
                  ASA 3E
                </div>
                <div
                  className={`${asaScore === '4E' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '4E' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('4E')}
                >
                  ASA 4E
                </div>
                <div
                  className={`${asaScore === '5E' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '5E' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('5E')}
                >
                  ASA 5E
                </div>
                <div
                  className={`${asaScore === '6E' ? 'selected' : ''} ${css(styles.menuItem, asaScore === '6E' && styles.selectedItem)}`}
                  onClick={() => handleOnClickAsa('6E')}
                >
                  ASA 6E
                </div>
              </div>
            </PopupMenu>
          }
        </div>
      </div>
      {/* Case Doc */}
      <CaseDoc
        showFlag={props.showFlag}
        formType={props.formType}
        flagType={props.flagType}
        scheduleId={props.scheduleId}
        caseDocs={props.caseDocs}
        isNone={props.isNone}
        onDeleteDocument={props.onDeleteDocument}
        onDeletePage={props.onDeletePage}
        onChangeIsNone={props.onChangeIsNone}
        onCaseDocUploaded={props.onCaseDocUploaded}
        onEdit={props.onEdit}
        onScanDocument={props.onScanDocument}
        onShowCropper={props.onShowCropper}
        onShowCamera={props.onShowCamera}
        onShowDocWriter={props.onShowDocWriter}
      />
    </div>
  );
};

PreOp.defaultProps = {
  asaScore: ''
};
export default PreOp;
